import { createElementSlot } from '@/lib/desktop-shell/element-slot';

/*
 * Where the side panel shown as a phone's screen (`presentation="screen"`) portals its tabs:
 * the active tab's name in the screen's header, and the list of its tabs in a sheet.
 */

export const panelTitleSlot = createElementSlot();
export const panelTabListSlot = createElementSlot();
